import axios from "axios";

// 환경 변수로 API URL 설정
// .env.local (로컬 개발): http://localhost:4002/
// .env (배포): https://backdev.healiary.com/
const API_BASE_URL = process.env.REACT_APP_API_URL || "https://backdev.healiary.com/";

export default axios.create({ baseURL: API_BASE_URL });

export const common = {
  baseURL: API_BASE_URL,
};

// 이전 설정 (참고용)
// 라이브 서버: https://back3.healiary.com/
// 개발 서버: https://backdev.healiary.com/
// 로컬 개발: http://localhost:4002/
